import addressTypes from '../../config/addressTypes'

export default {
  addressType: addressTypes.lookingLocal,
  packageName: "uk.gov.lookinglocal.scankirklees.app25prod"
}
